import Conference from "../../entity/conference"
import * as types from "./mutation_types"

const actions = {
    async getCurrentConference({ commit, state }) {
        // commit(types.CUREENT_USER_GET_ERROR, null);
        const url = process.env.VUE_APP_API_URL + "api/v1/conference";
        if (state.isCurrentConferenceFetched !=null) {
          await state.isCurrentConferenceFetched
          return state.currentConference
        } else {
          const waitableFetch = new Promise((resolve) => {
            this.currentConferenceResolver = resolve      
          });
          commit('setCurrentConferenceFetchPromise', waitableFetch);
          const conference = await axios
            .get(url, { params: {status:"发布"} })
            .then((res) => {
              let conference = {};
              conference = Object.assign(conference, res.data.results[0]);
              this.currentConferenceResolver(true)
              commit(types.CURRENT_CONFERENCE_UPDATE, conference);          
              return conference;
            })
            .catch((e) => {
              commit(types.CUREENT_CONFERENCE_ERROR, "failed to fetch current conference");
              return new Conference();
            });
          return conference
        }
      },
}

function initialState() {
  return {
    currentConference: {},
    isCurrentConferenceFetched: null
  }
}

const state = initialState()

const getters = {}

const mutations = {
    setCurrentConferenceFetchPromise(state, waitableFetch) {
        state.isCurrentConferenceFetched = waitableFetch
      },
    [types.CURRENT_CONFERENCE_UPDATE](state, conference) {
        state.currentConference = conference;
      },
    [types.CUREENT_CONFERENCE_ERROR](state) {
        state.currentConference = null;
        const s = initialState();
        Object.keys(s).forEach((key) => {
          state[key] = s[key];
        });
      },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}